const validateEmail = (email) => String(email)
    .toLowerCase()
    .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );

const inputsEmail = document.querySelectorAll('input[type="email"]')

if (inputsEmail.length) {
    inputsEmail.forEach(input => {
        input.addEventListener('input', () => {
            if (validateEmail(input.value)) {
                input.classList.remove('is-error')
            } else {
                input.classList.add('is-error')
            }
        })
    })
}

const forms = document.querySelectorAll('form')

const validate = (field) => {

    if (field.classList.contains('textarea')) {
        return !field.classList.contains('is-error');
    }


    if(field.type === 'email' && field.classList.contains('is-error')) {
        return false
    }

    if (!field.value?.trim()) {
        return false
    }

    if (field.textContent.trim().length > 0) {

        return false
    }

    return true
}

if (forms.length) {
    forms.forEach(form => {
        const formData = new FormData(form);
        const formProps = Object.fromEntries(formData);
        const fields = form.querySelectorAll('input:not([type="hidden"]), .textarea');
        const sumbit = form.querySelector('.form__submit button')
        let error = false

        if (!sumbit) return

        fields.forEach(field => {

            if (!validate(field)) {
                error = true
            }

            field.addEventListener('input', event => {
                error = false

                fields.forEach(item => {
                    if (!validate(item)) {
                        error = true
                    }
                })

                if (form.classList.contains('js-pdf-form')
                    && !document.querySelector('.modal__loader').classList.contains('is-loaded')
                ) {
                    error = true
                } else {
                    error = false
                }

                if (!error) {
                    sumbit.disabled = false
                } else {
                    sumbit.disabled = true
                }
            })
        })

        if (form.classList.contains('js-pdf-form')
            && !document.querySelector('.modal__loader').classList.contains('is-loaded')
        ) {
            error = true
        } else {
            error = false
        }

        if (!error) {
            sumbit.disabled = false
        } else {
            sumbit.disabled = true
        }

        form.addEventListener('submit', (e) => {
            e.target.querySelectorAll('.input-field-helper-line').forEach(item => {
                item.remove()
            })
        })
    })
}


const formsList = document.querySelectorAll('[data-form-name]')
formsList.forEach(form => {
  const submitButton = form.querySelector('button[type=submit],input[type=submit]')

  form.addEventListener('submit', (e) => {
    e.preventDefault()

    submitButton.disabled = true
    const formData = new FormData(form);

    const values = Array.from(formData.values())
    if (values.every(item => item === '')) {
        const input = form.querySelector('input')
        const parent = input.closest('.input-field-container')
        input.classList.add('is-error')
        parent.insertAdjacentHTML('beforeend',
            `<div class="input-field-helper-line">
                    <div class="input-field-helper-text is-danger">
                        ${form.dataset.formLanguage === 'ky' ? 'Сиз бош форманы жөнөтүүгө аракет кылып жатасыз' : 'Вы пытаетесь отправить пустую форму'}
                    </div>
                </div>`
        )
        submitButton.disabled = false
        return
    }

    form.querySelector('.form-result')?.remove()

    const url = new URL(window.location.href)

    formData.append('source', url.hostname);
    formData.append('path', url.pathname)
    formData.append('form', form.dataset.formName)
    formData.append('lang', form.dataset.formLanguage)
    formData.append('utm', form.dataset.formUtm)

    fetch('https://api.easykassa.com/v1-notification-service/message?uuid=5a1f1f2f', {
      method: 'POST',
      body: formData
    }).then(async (response) => {
      const json = await response.json()

      if (response.ok) {
        if (form.dataset.formName !== 'review' && typeof window.ym === 'function') {
          window.ym(103813543, 'reachGoal', 'lead')
        }

        // const msg = `<div class="form-result">${json.msg}</div>`
        // form.insertAdjacentHTML('beforeend', msg)

        const container = form.closest('.modal-container')

        if (container) {
          container.querySelector('.js-modal-close').click()
        }

        const containerOld = form.closest('.js-popup')
        if (containerOld) {
          document.querySelector('.js-overlay')?.click()
        }

        const modl = document.querySelector('#modal-accepted');

        if (modl) {
          modl.querySelector('.modal__title').textContent = json.title
          modl.querySelector('.modal__desc').textContent = json.msg
        }

        form.classList.add('is-success')

        form.querySelector('.form__hidden')?.click()

        form.reset()

        return json;
      }

      const msg = `<div class="form-result is-error">${json.msg}</div>`

      form.insertAdjacentHTML('beforeend', msg)

      Object.keys(json.errors).forEach(field => {
        const el = form.querySelector(`[name=${field}]`)
        // const input = el.querySelector('input')
        el.classList.add('is-error')

        const parent = el.closest('.input-field-container')
        parent.querySelector('.input-field-helper-line')?.remove()

        // input.classList.add('is-error')
        parent.insertAdjacentHTML('beforeend',
          `<div class="input-field-helper-line">
                            <div class="input-field-helper-text is-danger">
                              ${json.errors[field]}
                            </div>
                          </div>`
        )
      })

      const err = new Error("Not 2xx response");
      err.response = response;
      throw err;

    }).catch((err) => {
      // There was an error
      console.warn('Something went wrong.', err);
    }).finally(() => {
      submitButton.disabled = false
    });

  })
})
